export const getPercent = (current, last) => {
    const difference = current - last;
    return Math.floor(last !== 0 ? difference * 100 / last : difference * 100 / (last + 0.0001));
}
